module.exports = __webpack_public_path__ + "img/Feature.4a608ced.png";